import { createContext, useEffect, useContext, useState } from 'react';
import PropTypes from 'prop-types';
import WebFont from 'webfontloader';

//* Web Font Loader documentation
// https://github.com/typekit/webfontloader

const FontLoadedContext = createContext();

export const FontLoadedProvider = ({ children }) => {
  const [fontLoaded, setFontLoaded] = useState(false);

  // Tricks to try to get the font loading status and the fontVariationSettings FILL: 1
  // const link = document.createElement('link');
  // link.href =
  //   'https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL@24,400,0..1&display=swap';
  // link.rel = 'stylesheet';
  // document.head.appendChild(link);

  useEffect(() => {
    // link.onload = () => {
    //   setFontLoaded(true);
    // };

    //! WebFont currently don't support the fontVariationSettings FILL: 1
    WebFont.load({
      google: {
        families: ['Material Symbols Outlined:400']
      }, // loading fonts
      active: () => {
        setFontLoaded(true);
      } // font is loaded
    });
  }, []);

  return <FontLoadedContext.Provider value={{ fontLoaded, setFontLoaded }}>{children}</FontLoadedContext.Provider>;
};

FontLoadedProvider.propTypes = {
  children: PropTypes.node
};

export const useFontLoaded = () => useContext(FontLoadedContext);
